var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0468 8.23125C10.5591 6.69444 12.5866 6.36542 13.5585 7.66138C14.1279 8.42052 14.0882 9.47458 13.4633 10.1887L12.5441 11.2392C11.7098 12.1927 11.25 13.4165 11.25 14.6834V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V14.6834C12.75 13.7798 13.078 12.907 13.673 12.227L14.5922 11.1765C15.6838 9.92892 15.7532 8.08755 14.7585 6.76138C13.0606 4.49743 9.5187 5.0722 8.62379 7.75691L8.28849 8.76283C8.1575 9.15579 8.36987 9.58053 8.76283 9.71151C9.15579 9.8425 9.58053 9.63013 9.71151 9.23717L10.0468 8.23125Z",
    fill: "#2D264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z",
    fill: "#2D264B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleIcon);
export default __webpack_public_path__ + "static/media/question-circle-icon.8e1ad0e2bb9851a2a2f7e65aa9293dfc.svg";
export { ForwardRef as ReactComponent };